module.exports = __webpack_public_path__ + "static/media/plus-white.9e5a6434.svg";